export default "__VITE_ASSET__Ck9s$l9r__"